import { createContext } from 'react';

export const initialState = {
  user: null,
  files: [],
};
const UserContext = createContext(initialState);

export default UserContext;
